import { gql } from "@apollo/client";

export default gql`
  mutation sendScheduledAiTestMutation($kind: String!) {
    sendScheduledAiTest(kind: $kind) {
      ok
    }
  }
`;
